import React, { Component } from 'react';
import { Label, Input, Button } from 'reactstrap';
import Select from 'react-select';
import IconBurger from 'images/burger-menu2.svg';

export default class GoogleDriveVideoUploader extends Component {
  constructor(props) {
    super(props);
  }
  
  // Define select styles as a class property to avoid duplication
  driveOptions = [
    { 
      value: 'delete_all', 
      label: '【全て削除】Googleドライブ側でデータを削除後、アカポンの全てのデータを削除',
      boldPart: '【全て削除】'
    },
    { 
      value: 'keep_comment', 
      label: '【コメントのみ残す】Googleドライブ側でデータを削除後、アカポンのコメントのみ残す',
      boldPart: '【コメントのみ残す】'
    },
    { 
      value: 'keep_all', 
      label: '【全て残す】Googleドライブ側でデータを削除後、アカポンの全てのデータを残す',
      boldPart: '【全て残す】'
    }
  ]
  mobileDriveOptions = [
    { 
      value: 'delete_all', 
      label: 'Googleドライブ側でデータを削除後、アカポンの全てのデータを削除',
      boldPart: ''
    },
    { 
      value: 'keep_comment', 
      label: 'Googleドライブ側でデータを削除後、アカポンのコメントのみ残す',
      boldPart: ''
    },
    { 
      value: 'keep_all', 
      label: 'Googleドライブ側でデータを削除後、アカポンの全てのデータを残す',
      boldPart: ''
    }
  ]
  selectStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      height: '26px',
      minHeight: '26px',
      border: '1px solid black',
      boxShadow: this.props.isMobile ? '0px 3px 6px #000000' : 'inherit',
      '&:hover': {
        border: '1px solid black',
      },
      width: this.props.isMobile ? 'inherit' : '600px'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    dropdownIndicator: () => ({
      display: 'none'
    }),
    valueContainer: (baseStyles) => ({
      ...baseStyles,
      height: '26px',
      padding: '0 4px'
    }),
    input: (baseStyles) => ({
      ...baseStyles,
      margin: '0',
      padding: '0',
      color: 'transparent'
    }),
    placeholder: (provided) => ({
      ...provided,
      position: 'static',
      transform: 'none',
    }),
    singleValue: (provided) => ({
      ...provided,
      position: 'static',
      transform: 'none',
      fontSize: this.props.isMobile ? '10px' : 'inherit',
    }),
    option: (provided) => ({
      ...provided,
      fontSize: this.props.isMobile ? '10px' : 'inherit',
      padding: '0 4px'
    }),
  }
  
  renderMobileContent() {
    const { 
      onInputChange, 
      onSelectChange, 
      userChoice, 
      isMobile 
    } = this.props;
    return (
      <React.Fragment>
        <div className="align-center-div div-upload-youtube mobile-google-container">
          <div className="row px-2 justify-content-between">
            <Label className="font-weight-bold mobile-label">
              動画のURL
            </Label>
            <a className="mobile-label font-weight-bold text-underline" style={{color: '#575757'}} target="_blank" href='https://drive.google.com/drive/home'>
              Googleドライブのアカウントへ移動
            </a>
          </div>
          <div className="row px-2">
            <div
              style={{width: '100%'}}
            >
              <Input
                type="text"
                placeholder="GoogleドライブのURLをいれてください。"
                name="link"
                style={{paddingLeft: '12px', height: '35px'}}
                onChange={onInputChange}
                className="mobile-input"
              />
            </div>
          </div>
        </div>
        <div className='row px-2 select-gdrive-logic d-flex flex-column justify-content-center mt-2 mobile-google-container'>
          <div className='pl-3 pr-3'>
            <p className='mobile-action-text font-weight-bold text-black mb-0'> 現在のデータ削除時のアクション：</p>
            <Select
              className='drive_file_handling_logic mobile-select'
              onChange={onSelectChange}
              value={this.mobileDriveOptions.find(option => option.value === userChoice)}
              options={this.mobileDriveOptions}
              placeholder="選択してください"
              styles={this.selectStyles}
              formatOptionLabel={(option) => {
                const { label, boldPart } = option;
                return (
                  <div className="mobile-option-label">
                    <strong>{label}</strong>
                  </div>
                );
              }}
            />
            <div className="mt-2">
              <div className='d-flex'>
                <span className="text-black mobile-note-label">※</span>
                <span className="text-black mobile-note-content">
                  ※アップロード後の「削除時アクション」の変更は、<br/>
                  該当のファイルページを開いている時、左上部にある「<img className="icon-upload text-black" style={{marginBottom: '2px'}} src={IconBurger} alt="アップロード" width="10" />」メニュー内「Google Drive」から変更できます。
                </span>
              </div>
            </div>

            <div className="mb-2 mt-3">
              <div className='d-flex'>
                <span className="text-black mobile-note-label">（注）</span>
                <span className="text-black mobile-note-content">
                  Googleドライブの権限とは異なります。<br/>
                  ファイルに招待されたメンバーは、全員動画を閲覧できます。<br/>
                  <b>対応形式：</b>MP4・MOV・WMV・AVI 
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="additional-akaire-button text-center">
          <Button color="primary" className="d-flex align-items-center text-white px-3 py-2 large-akaire-button mobile-button">アップロードする</Button>
        </div>
      </React.Fragment>
    );
  }

  renderDesktopContent() {
    const { 
      onInputChange, 
      onSelectChange, 
      userChoice, 
      driveOptions, 
      isMobile 
    } = this.props;
    
    return (
      <React.Fragment>
        <div className="align-center-div div-upload-youtube">
          <div className="row">
            <div
              className={`col-md-10 col-sm-10 pr-0`}
            >
              <div className="d-flex justify-content-between">
                <Label className="font-weight-bold h6">
                  動画のURL
                </Label>
                <a className="font-weight-bold text-underline" style={{color: '#575757'}} target="_blank" href='https://drive.google.com/drive/home'>
                  Googleドライブのアカウントへ移動
                </a>
              </div>
              <Input
                type="text"
                placeholder="GoogleドライブのURLをいれてください。"
                name="link"
                style={{paddingLeft: '12px'}}
                onChange={onInputChange}
              />
            </div>
          </div>
        </div>
        <div className='select-gdrive-logic d-flex justify-content-center mt-2'>
          <div style={{paddingLeft: '10%'}}>
            <div className='d-flex'>
              <p className='mb-0' style={{marginTop: '2px'}}> 現在のデータ削除時のアクション：</p>
              <Select
                className='drive_file_handling_logic'
                onChange={onSelectChange}
                value={this.driveOptions.find(option => option.value === userChoice)}
                options={this.driveOptions}
                autosize={true}
                placeholder="選択してください"
                styles={this.selectStyles}
                formatOptionLabel={(option) => {
                  const { label, boldPart } = option;
                  const parts = label.split(boldPart);
                  return (
                    <div>
                      {parts[0]}<strong>{boldPart}</strong>{parts[1]}
                    </div>
                  );
                }}
              />
            </div>
            <span className='d-flex justify-content-center'>
              ※アップロード後の「削除時アクション」の変更は、該当のファイルページを開いている時、左上部にある「<img className="icon-upload text-black" style={{marginBottom: '2px'}} src={IconBurger} alt="アップロード" width="18" />」メニュー内「Google Drive」から変更できます。
            </span>
          </div>
        </div>

        <div className="mb-3 mt-3 d-flex justify-content-center">
          <div className='d-flex'>
            <span>（注）</span>
            <span style={{color: '#6E6E6E', opacity: '1'}}>
              Googleドライブの権限とは異なります。ファイルに招待されたメンバーは、全員動画を閲覧できます。<br/>
              <b>対応形式：</b>MP4・MOV・WMV・AVI 
            </span>
          </div>
        </div>
        <div className="additional-akaire-button text-center">
          <Button color="primary" className="d-flex align-items-center text-white px-4 py-2 large-akaire-button">アップロードする</Button>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { isMobile } = this.props;
    return isMobile ? this.renderMobileContent() : this.renderDesktopContent();
  }
}
